module.exports = __webpack_public_path__ + "templates/product_attributes_selector.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/products/templates/product_attributes_selector.html
// module id = xSsJ
// module chunks = 1